export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8535.02e9dcaa.jpg";